export default {
//   login: {
//     title: "登录",
//     username: "用户名",
//     password: "密码",
//     submit: "登录",
//     reset: "重置"
//   },
//   client: {
//     title: "客户列表",
//     sales: "销售人员",
//     export: "导出 Excel",
//     filter_placeholder: "按销售筛选"
//   },
//   survey: {
//     title: "Panda Scanner - 客户支持问卷",
//     intro: `感谢您对 Panda Scanner 的关注。为了给您提供更及时、准确的支持，
// 请您选择所在国家或地区，我们将为您分配合适的销售人员。`,
//     intro2: `您的信息仅用于客户支持和服务协调。`,
//     name: "姓名",
//     email: "邮箱",
//     whatsapp: "WhatsApp 号码",
//     occupation: "职业",
//     country: "国家或地区",
//     selectCountry: "请选择国家或地区",

//     submit: "提交",

//     placeholder: {
//       name: "请输入您的姓名",
//       email: "请输入您的邮箱",
//       whatsapp: "例如：+86 138 0000 0000"
//     },

//     validation: {
//       name: "请输入姓名",
//       required: "此项为必填项",
//       emailRequired: "请输入邮箱",
//       emailInvalid: "请输入正确的邮箱",
//       country: "请选择国家或地区"
//     },

//     sales: {
//       title: "您的区域销售联系人",
//       noSalesTitle: "添加销售联系人",
//       desc: "我们的本地区域销售将为您提供产品咨询与合作支持。",
//       noDesc: "该地区暂无销售人员，请联系现场工作人员添加。",
//       whatsapp: "WhatsApp",
//       email: "邮箱",
//       add: "添加",
//       edit: "编辑销售联系人"
//     },

//     dialog: {
//       add: "添加销售联系人",
//       edit: "编辑销售联系人",
//       cancel: "取消",
//       save: "保存"
//     },

//     tip: {
//       succeeded: "提交成功！",
//       failed: "提交失败！"
//     },

//     occupations: {
//       DENTIST: '牙医',
//       DISTRIBUTOR: '经销商',
//       DENTAL_LAB: '加工厂',
//       KOL: '行业专家',
//       OTHER: '其他',
//       UNKNOWN: '未知'
//     }
//   }
}
